const strict = true;

const getDefaultState = () => {
  return {
    successDialog: {
      active: false,
      title: "",
      message: "",
      params: {
        title: null,
        msg: null
      },
      closeButtonLabel: "",
      closeButtonClb: null
    }
  };
};

const state = getDefaultState();

const getters = {
  successDialog: state => state.successDialog
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  openSuccessDialog(
    state,
    { title, message, closeButtonLabel, closeButtonClb, params }
  ) {
    state.successDialog.active = true;
    state.successDialog.title = title;
    state.successDialog.message = message;
    state.successDialog.params = params;
    state.successDialog.closeButtonLabel = closeButtonLabel;
    state.successDialog.closeButtonClb = closeButtonClb;
  },
  closeSuccessDialog(state) {
    state.successDialog = {
      active: false,
      title: "",
      message: "",
      params: {
        title: null,
        msg: null
      },
      closeButtonLabel: "",
      closeButtonClb: null
    };
  }
};

const actions = {};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
